
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 8a2 2 0 100-4 2 2 0 000 4zm4 4c-.383-.603-.958-1.109-1.663-1.461A5.247 5.247 0 009 10a5.24 5.24 0 00-2.337.539c-.705.352-1.28.858-1.663 1.461"}}),_c('path',{attrs:{"d":"M8.777 16.93a8.153 8.153 0 100-16.305 8.153 8.153 0 000 16.305zm10.598 2.445l-4.833-4.833"}})])
          )
        }
      }
    